<input
  class="image-upload__input"
  type="file"
  accept="image/*"
  hidden
  #fileInput
  (change)="onFileSelected($event)"
/>

<div
  class="image-upload image-upload__wrapper"
  (click)="triggerFileDialog()"
  (dragover)="onDragOver($event)"
  (dragenter)="onDragEnter($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  [class.image-upload--drag-over]="dragOverActive()"
>
  @if (preview()) {
    <div class="image-upload__preview image-upload__preview--has-image">
      <img class="image-upload__img" [src]="preview()"/>

      @if (dragOverActive()) {
        <div class="image-upload__overlay image-upload__overlay--drag">
          <p>
            <ogs-m3-icon prefix="fal" icon="file-upload"/>
          </p>
          <p>{{ "Foto hier loslassen" | translate: "paragraph-drop-image" : translationScope }}</p>
        </div>
      }

      <div class="image-upload__overlay image-upload__overlay--hover">
        <div class="image-upload__instructions">
          <p>
            <ogs-m3-icon prefix="fal" icon="file-upload"/>
          </p>
          <p>{{ "Foto hochladen" | translate: "paragraph-upload-image" : translationScope }}</p>
          <p>
            {{ "Datei reinziehen oder" | translate: "paragraph-drag-file" : translationScope }}
            <u>{{ "auswählen" | translate: "paragraph-choose" : translationScope }}</u>
          </p>
        </div>
      </div>
    </div>
  } @else {
    <div class="image-upload__dropzone">
      @if (dragOverActive()) {
        <div class="image-upload__overlay image-upload__overlay--drag">
          <p>
            <ogs-m3-icon prefix="fal" icon="file-upload"/>
          </p>
          <p>{{ "Foto hier loslassen" | translate: "paragraph-drop-image" : translationScope }}</p>
        </div>
      } @else {
        <div class="image-upload__instructions">
          <p>
            <ogs-m3-icon prefix="fal" icon="file-upload"/>
          </p>
          <p>{{ "Foto hochladen" | translate: "paragraph-upload-image" : translationScope }}</p>
          <p>
            {{ "Datei reinziehen oder" | translate: "paragraph-drag-file" : translationScope }}
            <u>{{ "auswählen" | translate: "paragraph-choose" : translationScope }}</u>
          </p>
        </div>
      }
    </div>
  }
</div>

<div class="image-upload__actions" (click)="$event.stopPropagation()">
  @if (preview()) {
    <button type="button" class="image-upload__btn" mat-icon-button (click)="enterCropMode()">
      <ogs-m3-icon prefix="fal" icon="crop"/>
    </button>
  }

  <button
    type="button"
    class="image-upload__btn"
    [disabled]="!preview()"

    mat-icon-button
    (click)="clearImage()"
  >
    <ogs-m3-icon prefix="fal" icon="trash"/>
  </button>

  <button type="button" class="image-upload__btn" mat-icon-button (click)="triggerFileDialog()">
    <ogs-m3-icon prefix="fal" icon="upload"/>
  </button>
</div>
